import { ToggleField } from 'components/core-v2'
import { Loading } from 'components/core-v2/pages'
import { FormProvider, useForm } from 'react-hook-form'

import { ApiAssetPriceWithHistory } from '../../../api'
import MarketDataTable from '../../../components/core-v2/organisms/market-data-table'

export type MarketDataStatelessProps = {
  data: ApiAssetPriceWithHistory[]
  isLoading: boolean
  onPriceOverrideClick: (selectedAssetPrice: ApiAssetPriceWithHistory) => void
}

const MarketDataStateless = ({
  data,
  isLoading,
  onPriceOverrideClick
}: MarketDataStatelessProps) => {
  const form = useForm({ defaultValues: { onlyManual: false } })
  const onlyManualValue = form.watch('onlyManual')
  const filteredData = onlyManualValue
    ? data.filter(x => x.allPrices?.some(price => price.isManuallyOverridden))
    : data

  return isLoading ? (
    <Loading className="mt-12" />
  ) : (
    <FormProvider {...form}>
      <ToggleField id="onlyManual" label="Display only manually updated prices" />
      <MarketDataTable data={filteredData} onShowPriceOverride={onPriceOverrideClick} />
    </FormProvider>
  )
}

export default MarketDataStateless
